<template>
  <div>
    <StaticDataTable class="static-table-list">
      <template v-slot:header>
        <tr>
          <th width="25%">Shift</th>
          <th width="40%">Days</th>
          <th width="15%">Start Time</th>
          <th width="15%">End Time</th>
          <th width="5%"><Tooltip helpStyle label="Set if the shift applies to the production system">Production</Tooltip></th>
          <th width="5%"><Tooltip helpStyle label="Set if the shift applies to the task system">Task</Tooltip></th>
          <th width="5%" v-if="editing">Action</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="shift in shiftList" :key="shift.id">
          <template v-if="!editing">
            <td class="font-weight-bold">{{shift.name}}</td>
            <td>{{shift.dayOfWeekFlags | formatDaysOfWeekList}}</td>
            <td>{{shift.shiftStartTime | formatTimeFromTimeOnly}}</td>
            <td>{{shift.shiftEndTime | formatTimeFromTimeOnly}}</td>
            <td><IconBoolean :value="shift.isProductionShift" /></td>
            <td><IconBoolean :value="shift.isTaskShift" /></td>
          </template>
          <template v-if="editing">
            <td>
              <FormInputText v-model="shift.name" @input="dataUpdated" />
            </td>
            <td>
              <FormDaysWeek v-model="shift.dayOfWeekFlags" @input="dataUpdated" />
            </td>
            <td>
              <FormTime v-model="shift.shiftStartTime" @input="dataUpdated" />
            </td>
            <td>
              <FormTime v-model="shift.shiftEndTime" @input="dataUpdated" />
            </td>
            <td>
              <FormCheckbox v-model="shift.isProductionShift" @change="dataUpdated" />
            </td>
            <td>
              <FormCheckbox v-model="shift.isTaskShift" @change="dataUpdated" />
            </td>
            <td>
              <ActionDropMenu :tableAction="true">
                <DropdownMenuItem @click="deleteShift(shift.id)" icon="fa-trash-alt">Delete Shift</DropdownMenuItem>
              </ActionDropMenu>
            </td>
          </template>
        </tr>
      </template>
      <template v-slot:empty v-if="shiftList.length == 0 && !editing">
        No shifts available
      </template>
    </StaticDataTable>
    <!-- Display warnings if shifts overlap || end < start -->
    <div v-if="shiftErrorList.length">
      <h2>Warning</h2>
      <p v-for="error of shiftErrorList" :key="error">
        <Icon iconStyle="fas" icon="fa-exclamation-triangle" class="text-danger mr-1"></Icon>{{error}}
      </p>
    </div>
    <div v-if="editing">
      <FormButton class="btn btn-primary btn-xs" @click="addShift"><i class="far fa-plus"></i> Add Shift</FormButton>
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'AvailabilityShiftList',
  props: {
    editing: Boolean,
    value: Array
  },
  watch: {
    value: function() {
      this.shiftList = _.cloneDeep(this.$props.value)
    }
  },
  computed: {
    shiftErrorList() {
      // Check if any two shifts on the same day overlap
      // Check if any shifts have end time before (or equal) to start time
      var shiftErrors = []

      this.shiftList.forEach(shift => {
        let startTime = moment(shift.shiftStartTime, "HH:mm:ss")
        let endTime = moment(shift.shiftEndTime, "HH:mm:ss")

        if(!startTime.isValid())
          shiftErrors.push(`Shift '${shift.name}' has an invalid start time`)
        if(!endTime.isValid())
          shiftErrors.push(`Shift '${shift.name}' has an invalid end time`)

        if(endTime.isBefore(startTime))
          shiftErrors.push(`Shift '${shift.name}' has an end time before start time`)
        
        this.shiftList.forEach(otherShift => {
          if(shift.id == otherShift.id)
            return

          let otherStartTime = moment(otherShift.shiftStartTime, "HH:mm:ss")
          let otherEndTime = moment(otherShift.shiftEndTime, "HH:mm:ss")
          
          if(startTime.isValid() && endTime.isValid() && otherStartTime.isValid() && otherEndTime.isValid()) {
            // Matching days?
            let hasMatchingDays = shift.dayOfWeekFlags.filter(shiftDayIndex => {
              if(otherShift.dayOfWeekFlags.length > 0) {
                if(shiftDayIndex == -1)
                  return true
                if(otherShift.dayOfWeekFlags[0] == -1 || otherShift.dayOfWeekFlags.indexOf(shiftDayIndex) != -1)
                  return true
              }
              return false
            }).length > 0
            
            if(hasMatchingDays) {
              if(startTime.isBetween(otherStartTime, otherEndTime) || endTime.isBetween(otherStartTime, otherEndTime) ||
                otherStartTime.isBetween(startTime, endTime) || otherEndTime.isBetween(startTime, endTime)) {

                shiftErrors.push(`Shift '${shift.name}' overlaps with '${otherShift.name}'`)
              }
            }
          }
        })

      })

      return shiftErrors
    }
  },
  data() {
    return {
      shiftList: _.cloneDeep(this.$props.value)
    }
  },
  methods: {
    addShift() {
      this.shiftList.push({
        id: `temp-id-` + uuidv4(),
        isNewShift: true,
        name: '',
        dayOfWeekFlags: [],
        shiftStartTime: '09:00:00',
        shiftEndTime: '17:00:00'
      })
      this.dataUpdated()
    },
    deleteShift(id) {
      this.shiftList = this.shiftList.filter(shift => shift.id != id)
      this.dataUpdated()
    },
    dataUpdated() {
      this.$emit('input', this.shiftList)
    }
  }
}
</script>